import { Input } from "@mantine/core";

import Icon       from "_components/atoms/icon";
import Typography from "_components/atoms/typography";
import useStyles  from "_styles/molecules/fanRankInput";

const component = props => {
	const {
		userProfile,
		fanRankAmount,
		handleAmountChange,
		errorMsg,
		type,
		defaultMsg
	} = props;

	const { classes } = useStyles ( { errorMsg }, { name: "styles" } );

	const getTag = type => {
		if ( type === "donation" )
			return (
				<Icon sameInBothTheme
					className = { classes.svgIcon }
					name      = "diamond"
				>
				</Icon>
			);

		if ( type === "fanRank" )
			return (
				<Icon sameInBothTheme
					className = { classes.svgIcon }
					name      = "rooterCoinIcon"
				/>
			);
	};

	const onChangeHandler = e => {
		if ( type === "donation" )
			handleAmountChange ( e );
		else
			handleAmountChange ( e, userProfile.totalPoints );

	};

	return (
		<div className = { classes.wrapper }>
			<Input
				fullWidth
				autoComplete = "off"
				className    = { classes.root }
				classNames   = { {
					root  : classes.label,
					input : classes.customInputField
				} }
				label       = ""
				leftSection = { getTag ( type ) }
				onChange    = { e => onChangeHandler ( e ) }
				placeholder = { "0" }
				radius      = { "lg" }
				size        = "xl"
				type        = "number"
				value       = { fanRankAmount }
			/>

			{
				errorMsg ? (
					<div
						className = { classes.errorMsg }
					>
						{errorMsg}
					</div>
				) : (
					<Typography
						className = { classes.normalMsg }
						color     = "secondary"
						title     = { defaultMsg }
					/>
				)
			}

		</div>
	);
};

export default component;
